export const stripInactiveCalcValues = (
  values: Record<string, any>,
  inactiveCalcVariables: Array<{ name: string; element?: string }>,
): Record<string, any> => {
  let result = values;
  const clonedBuckets = new Set<string>();

  inactiveCalcVariables.forEach(({ name, element }) => {
    if (element) {
      if (!result[element] || typeof result[element] !== 'object' || !(name in result[element])) return;
      if (result === values) result = { ...values };
      if (!clonedBuckets.has(element)) {
        result[element] = { ...result[element] };
        clonedBuckets.add(element);
      }
      delete result[element][name];
      return;
    }
    if (!(name in result)) return;
    if (result === values) result = { ...values };
    delete result[name];
  });

  return result;
};

export default stripInactiveCalcValues;
